import type { TFunction } from 'i18next';
import type { RowAction } from 'design-system-web';

import { CoverageHoursEntry } from './useCoverageHours';

export function buildCoverageHoursRowActions(
  t: TFunction
): RowAction<CoverageHoursEntry>[] {
  return [
    {
      label: t('web.admin.serviceRequest.settings.coverageHours.actions.edit'),
      onClick: () => undefined,
      testId: 'coverageHoursRowActionEdit',
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.actions.delete'
      ),
      onClick: () => undefined,
      testId: 'coverageHoursRowActionDelete',
    },
  ];
}
